
import Router from './Router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "react-chat-elements/dist/main.css"
import ChatUs from './components/ChatUs';
import NotificationInitializer from './components/NotificationInitializer';

function App() {
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <NotificationInitializer />
      <Router />
      {/* <ChatUs /> */}
    </div>
  );
}

export default App;
